import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { renderMarkers } from './markers';
import { renderWrappedText } from './textUtils';
import { getThemeStyle } from '../theme';

class CallActivityView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height, radius } = model;
    const style = model.getNodeStyle();
    const props = model.properties || {};

    // Arrow icon position (top-left corner)
    const ix = x - width / 2 + 8;
    const iy = y - height / 2 + 6;

    const children = [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        rx: radius,
        ry: radius,
        ...style,
      }),
      // BPMN Call Activity icon (right-pointing arrow)
      h('path', {
        d: `M ${ix} ${iy + 3} L ${ix + 8} ${iy + 3} L ${ix + 8} ${iy} L ${ix + 13} ${iy + 6} L ${ix + 8} ${iy + 12} L ${ix + 8} ${iy + 9} L ${ix} ${iy + 9} Z`,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 1.2,
      }),
    ];

    const label = (props && props.name) || '';
    if (label) {
      children.push(renderWrappedText(h, label, x, y + 4, width - 20, { graphModel: model.graphModel }));
    }

    children.push(...renderMarkers(x, y, width, height, props, style.stroke));

    return h('g', {}, children);
  }
}

class CallActivityModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 120;
    this.height = 60;
    this.radius = 5;
    this.text = { ...this.text, editable: false, draggable: false, value: '' };
  }


  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'callActivity');
    style.stroke = t.stroke || '#389e0d';
    style.strokeWidth = t.strokeWidth ?? 3;
    style.fill = t.fill || '#f6ffed';
    return style;
  }
}

export const CallActivity = {
  type: 'epx:CallActivity',
  view: CallActivityView,
  model: CallActivityModel,
};
